import CopyIcon from '@/assets/copy.svg?url';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import useStyles from './CopyComponent.styles';

type Props = {
  copyToClipboard: () => void;
};

const CopyButton = ({copyToClipboard}: Props) => {
  const classes = useStyles({});
  return (
    <Button onClick={copyToClipboard}>
      <Box
        component="img"
        src={CopyIcon}
        alt="Copy Icon"
        className={classes.copyIcon}
      />

      <Typography className={classes.copySheetButtonText}>Copy</Typography>
    </Button>
  );
};

export default CopyButton;
